import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const cardRoutes: RouteObject[] = [
  {
    path: '/card/inventory',
    element: lazyElement(() => import('./inventory/Inventory')),
    handle: {
      documentTitle: 'Phone Card Inventory',
      crumb: () => ({ label: 'Phone Card Inventory', to: '/card/inventory' })
    },
  },
  {
    path: '/card/transfer',
    element: lazyElement(() => import('./TransferValue')),
    handle: {
      documentTitle: 'Transfer',
      crumb: () => ({ label: 'Transfer', to: '/card/transfer' })
    },
  },
  {
    path: '/card/change-value',
    element: lazyElement(() => import('./ChangeValue')),
    handle: {
      documentTitle: 'Change Value',
      crumb: () => ({ label: 'Change Value', to: '/card/change-value' })
    },
  },
  {
    path: '/card/:accountNumber',
    element: lazyElement(() => import('./view/View')),
    handle: {
      documentTitle: 'Card Account',
      crumb: () => ({ label: 'Card Account' })
    },
  },
];

export default cardRoutes;
